<template>
  <form @submit.prevent="$emit('submit')">
    <slot />
    <UiCardActions v-if="$slots['actions']" class="actions">
      <slot name="actions" />
    </UiCardActions>
  </form>
</template>

<script setup lang="ts">
import { UiCardActions } from '~/ui';

defineEmits<(e: 'submit') => void>();
</script>

<style lang="scss" scoped>
.actions {
  min-height: inherit;
  padding: 0;
}
</style>
